module.exports = __webpack_public_path__ + "img/birthday-template.226237b2.png";